import { Injectable } from '@angular/core';
import { URL_ANCILLARIES_SELECTION, MOCK_STATUS, EXTRAS_ANCILLARY_SEAT, URL_ANCILLARIES_APPLY_ALL_FLIGHTS, MOCK_URL_UPDATE_ANCILLARY_PAYMENT_TYPE, MOCK_ANCILLARIES_HUB_RESPONSE, MOCK_ANCILLARIES_HUB_BUNDLES_RESPONSE } from '@ibe.config';
import { INDRAAncillariesSelection, INDRAAncillariesSelectionElement, INDRAAncillariesSelectionItems, INDRAAncillariesSelectionConfirmation, INDRAAncillariesSelectionAllFlightParam, INDRAAncillariesListSelection } from '@ibe.models/ancillaries-selection.indra.model.lib';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { Observable, BehaviorSubject, forkJoin, of } from 'rxjs';
import { INDRAApiService } from './api.indra.service';
import { Router } from '@angular/router';
import { concatMap, takeWhile } from 'rxjs/operators';
import { INDRAAncillariesShoppingCartService } from './ancillaries-shopping-cart.indra.service';
import { from } from 'rxjs';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRAIbeAdminConfigService } from './ibeadmin-config.service';
import { BookedTrip } from '@ibe/models';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';

@Injectable({
	providedIn: 'root'
})
export class INDRAAncillariesSelectionService {

	private ancillariesByItemId: Map<number, INDRAAncillariesSelectionItems>;
	currentAddedAncMiles: number = 0;
	
	public payWithMilesFlightList: any = [];
	public notEnoughMilesFlag:boolean = false;

	limitNegativeFFLevelMiles: number;
	limitNegativeFFLevelSilver: number;
	limitNegativeFFLevelGold: number;
	limitNegativeFFLevelNavigator: number;

	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	bookedTrip: BookedTrip;
	isAlive = true;

	constructor(
		private api: INDRAApiService,
		private router: Router,
		protected ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		private paymentInfoService: PaymentService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private store: Store<fromStore.State>
		) {
		this.ancillariesByItemId = new Map<number, INDRAAncillariesSelectionItems>();
		this.limitNegativeFFLevelMiles = Number(this.ibeAdminConfigService.getConfigurationValue('bookingSearch.limitNegativeFFLevelMiles'));
		this.limitNegativeFFLevelSilver = Number(this.ibeAdminConfigService.getConfigurationValue('bookingSearch.limitNegativeFFLevelSilver'));
		this.limitNegativeFFLevelGold = Number(this.ibeAdminConfigService.getConfigurationValue('bookingSearch.limitNegativeFFLevelGold'));
		this.limitNegativeFFLevelNavigator = Number(this.ibeAdminConfigService.getConfigurationValue('bookingSearch.limitNegativeFFLevelNavigator'));

		this.bookedTrip$
		.pipe(takeWhile(() => this.isAlive))
		.subscribe(trip => {
			this.bookedTrip = trip;
		});
	}

	public INDRA_addAncillariesSelectionItems(addedAncillaries: INDRAAddOnAncillary[]) {
		let serviceCode: string = "";
		addedAncillaries.forEach(addOnAncillary => {
			serviceCode = addOnAncillary.serviceCode;
			const selectionElement: INDRAAncillariesSelectionElement = {
				amount: 1,
				code: addOnAncillary.code,
				idFlight: addOnAncillary.flightId,
				idPax: addOnAncillary.paxId,
				paxTattoo: addOnAncillary.paxTatto,
				idSegment: addOnAncillary.segmentId,
				ssrTattoo: addOnAncillary.ssrTatto,
				value: addOnAncillary.value,
				serviceCode: serviceCode
			};

			if (addOnAncillary.type === EXTRAS_ANCILLARY_SEAT && addOnAncillary.seatType) {
				selectionElement.additionalData = addOnAncillary.seatType;				
			}

			this.INDRA_addAncillariesSelectionElement(addOnAncillary.itemId, addOnAncillary.type, selectionElement);

			// We add selection of flight based ancillaries for the rest of the segments
			if (addOnAncillary.flightBased === true) {
				addOnAncillary.flightBasedAddOns.forEach(flightBasedAddOn => {
					serviceCode = flightBasedAddOn.serviceCode;
					const selectionElementFB: INDRAAncillariesSelectionElement = {
						amount: 1,
						code: flightBasedAddOn.code,
						idFlight: flightBasedAddOn.flightId,
						idPax: flightBasedAddOn.paxId,
						paxTattoo: flightBasedAddOn.paxTatto,
						idSegment: flightBasedAddOn.segmentId,
						ssrTattoo: flightBasedAddOn.ssrTatto,
						value: flightBasedAddOn.value,
						serviceCode: serviceCode
					};

					if (addOnAncillary.type === EXTRAS_ANCILLARY_SEAT && flightBasedAddOn.seatType) {
						selectionElementFB.additionalData = flightBasedAddOn.seatType;
					}

					this.INDRA_addAncillariesSelectionElement(flightBasedAddOn.itemId, flightBasedAddOn.type, selectionElementFB);
				});
			}
		});
	}

	private INDRA_addAncillariesSelectionElement(itemId: number, type: string, selectionElement: INDRAAncillariesSelectionElement) {
		if (this.ancillariesByItemId.has(itemId)) {
			const items = this.ancillariesByItemId.get(itemId);

			const index = items.selection.findIndex(
				item => item.code === selectionElement.code && item.idPax === selectionElement.idPax && item.idSegment === selectionElement.idSegment &&
					(selectionElement.ssrTattoo == undefined || item.ssrTattoo === selectionElement.ssrTattoo)
			);
			if (index >= 0) {
				items.selection[index].amount++;
			} else {
				items.selection.push(selectionElement);
			}
		} else {
			const selection: INDRAAncillariesSelectionElement[] = [selectionElement];
			const item: INDRAAncillariesSelectionItems = { itemId, type, selection };
			this.ancillariesByItemId.set(itemId, item);
		}
	}

	public INDRA_clearAncById() {
		this.ancillariesByItemId.clear();
	}

	public INDRA_doAncillariesSelection(pnr: string, award: boolean): Observable<INDRAAncillariesSelectionConfirmation> {
		const ancillaryList = Array.from(this.ancillariesByItemId.values());
		const ancillariesSelection: INDRAAncillariesSelection = { ancillaryList: ancillaryList, pnr: pnr };

		if (ancillariesSelection.ancillaryList.length) {
			ancillariesSelection.ancillaryList[0].selection.forEach(anc => {
				anc['spendPoints'] = award;
				if (anc.idSegment !== 1) {
					anc.serviceCode = null;
				}
			});
		}

		this.ancillariesByItemId.clear();
		if (ancillaryList.length === 0 || MOCK_STATUS.ANCILLARIES_SELECTION) {
			const resp: INDRAAncillariesSelectionConfirmation = { 'status': '200', 'errors': [], 'timeService': null, 'timeBackend': null, 'selectedAncillaries': [] };
			return new BehaviorSubject(resp).asObservable();
		} else
			return this.api.INDRA_post<INDRAAncillariesSelectionConfirmation>(URL_ANCILLARIES_SELECTION, ancillariesSelection);
	}

	public INDRA_doAncillariesDeletion(pnr: string): Observable<INDRAAncillariesSelectionConfirmation> {
		const ancillaryList = Array.from(this.ancillariesByItemId.values());
		const ancillariesSelection: INDRAAncillariesSelection = { ancillaryList: ancillaryList, pnr: pnr };
		this.ancillariesByItemId.clear();
		ancillariesSelection.ancillaryList.forEach(ancillaryItem => {
			if (ancillaryItem.type === EXTRAS_ANCILLARY_SEAT) {
				// manipulate the delete request for seat to include only the 6 attributes below..
				ancillaryItem.selection = ancillaryItem.selection.map(selectionItem => {
					const newSelectionItem = {
						idFlight: selectionItem.idFlight,
						idSegment: selectionItem.idSegment,
						idPax: selectionItem.idPax,
						paxTattoo: selectionItem.paxTattoo,
						code: selectionItem.code,
						amount: selectionItem.amount,
						serviceCode: selectionItem.idSegment !== 1 ? null : selectionItem.serviceCode
					};
					// ..and the ssrTattoo when is present
					if (selectionItem.ssrTattoo) {
						newSelectionItem['ssrTattoo'] = selectionItem.ssrTattoo;
					}
					return newSelectionItem;
				});
			}
		});
		if (ancillaryList.length === 0 || MOCK_STATUS.ANCILLARIES_SELECTION) {
			const resp: INDRAAncillariesSelectionConfirmation = { 'status': '200', 'errors': [], 'timeService': null, 'timeBackend': null, 'selectedAncillaries': [] };
			return new BehaviorSubject(resp).asObservable();
		} else {
			return this.api.INDRA_delete<INDRAAncillariesSelectionConfirmation>(URL_ANCILLARIES_SELECTION, ancillariesSelection);
		}
	}

	public INDRA_doBundleSelection(pack: any, pnr: string, passengers: any, segments: any, flightBased: boolean = false, seatSelection?: any): Observable<INDRAAncillariesSelectionConfirmation> {
		let packsPassengerSelection = [];
		passengers.forEach(passenger => {
			if (flightBased) {
				// If pack is flight-based, add for all segments
				segments.forEach(segment => {
					let selectionRequest: any = {
						amount: 1,
						code: pack.passengers[0].codeList[0].code,
						idFlight: pack.flightId,
						idPax: passenger.idPax,
						paxTattoo: passenger.tatoo,
						idSegment: segment.idInfoSegment,
						serviceCode: pack.passengers[0].codeList[0].serviceCode,
						additionalData: null,
						spendPoints: false
					}
					if (seatSelection) {
						selectionRequest = {...selectionRequest, value: seatSelection[passenger.idPax][segment.idInfoSegment]}
					}
					packsPassengerSelection.push(selectionRequest);
				});
			} else {
				let segment = segments.find(segment => segment.idInfoSegment === pack.segmentId);
				let selectionRequest: any = {
					amount: 1,
					code: pack.passengers[0].codeList[0].code,
					idFlight: pack.flightId,
					idPax: passenger.idPax,
					paxTattoo: passenger.tatoo,
					idSegment: segment.idInfoSegment,
					serviceCode: pack.passengers[0].codeList[0].serviceCode,
					additionalData: null,
					spendPoints: false
				}
				if (seatSelection) {
					selectionRequest = {...selectionRequest, value: seatSelection[passenger.idPax][segment.idInfoSegment]}
				}
				packsPassengerSelection.push(selectionRequest);
			}	
		});
		let packRequest = {
			packList: [{
				itemId: pack.itemId,
				type: pack.type,
				selection: packsPassengerSelection
			}],
			pnr: pnr
		}
		if (MOCK_STATUS.BUNDLES_SELECTION) {
			const resp = this.api.INDRA_get<INDRAAncillariesSelectionConfirmation>(MOCK_ANCILLARIES_HUB_BUNDLES_RESPONSE);
			return resp;
		} else {
			return this.api.INDRA_post<INDRAAncillariesSelectionConfirmation>(URL_ANCILLARIES_SELECTION, packRequest);
		}
	}

	public INDRA_doBundleDeletion(pack: any, pnr: string, passengers: any, segments: any, shoppingBasketPacks: any): Observable<INDRAAncillariesSelectionConfirmation> {
		let packsPassengerSelection = [];
		pack.forEach(pck => {
			pck.passengers.forEach(passenger => {
				segments.forEach(segment => {
					let addedPack = shoppingBasketPacks.find(anc => anc.flightId.toString() === pck.flightId.toString() && anc.segmentId.toString() === pck.segmentId.toString() && anc.code === pck.type);
					if (segment.idInfoSegment === pck.segmentId && addedPack) {

						packsPassengerSelection.push({
							amount: 1,
							code: passenger.codeList[0].code,
							idFlight: pck.flightId,
							idPax: passenger.paxId,
							paxTattoo: passenger.paxTattoo,
							idSegment: segment.idInfoSegment,
							serviceCode: passenger.codeList[0].serviceCode,
							additionalData: null,
							spendPoints: false
						});
					}
				});
			});
		});
		let packRequest = {
			packList: [{
				itemId: pack[0].itemId,
				type: pack[0].type,
				selection: packsPassengerSelection
			}],
			pnr: pnr
		}
		if (MOCK_STATUS.BUNDLES_SELECTION) {
			const resp = this.api.INDRA_get<INDRAAncillariesSelectionConfirmation>(MOCK_ANCILLARIES_HUB_RESPONSE);
			return resp;
		} else {
			return this.api.INDRA_delete<INDRAAncillariesSelectionConfirmation>(URL_ANCILLARIES_SELECTION, packRequest);

		}
	}

	public INDRA_updateAncillariesPaymentType(pnr: string, awards: boolean, ancillaryToUpdate?) {
		const ancillaryList = Array.from(this.ancillariesByItemId.values());
		const ancillariesSelection: INDRAAncillariesSelection = { ancillaryList: ancillaryList, pnr: pnr };
		if (ancillariesSelection.ancillaryList.length >= 2) {
			ancillariesSelection.ancillaryList.forEach(ancillary => {
				ancillary.selection.forEach((anc, i) => {
					if (ancillaryToUpdate) {
						ancillaryToUpdate.forEach(el => {
							// check if ancillary has updated price due to tier benefit 
							if (el.value === anc.value && el.segmentId === anc.idSegment && el.paxId === anc.idPax && el.flightId === anc.idFlight  && !el.points && !el.price && el['oldPoints'] && el['oldPrice']) {
								ancillariesSelection.ancillaryList[0].selection.splice(i, 1);
							} else {
								anc['spendPoints'] = awards;
							}
						});
					} else {
						anc['spendPoints'] = awards;
					}
				})
			})
		} else if (ancillariesSelection.ancillaryList.length) {
			ancillariesSelection.ancillaryList[0].selection.forEach((anc, i) => {
				if (ancillaryToUpdate) {
					ancillaryToUpdate.forEach(el => {
						// check if ancillary has updated price due to tier benefit 
						if (el.value === anc.value && el.segmentId === anc.idSegment && el.paxId === anc.idPax && el.flightId === anc.idFlight  && !el.points && !el.price && el['oldPoints'] && el['oldPrice']) {
							ancillariesSelection.ancillaryList[0].selection.splice(i, 1);
						} else {
							anc['spendPoints'] = awards;
						}
					});
				} else {
					anc['spendPoints'] = awards;
				}
				if (anc.idSegment !== 1) {
					anc.serviceCode = null;
				}
			});
		}
		this.ancillariesByItemId.clear();

		if (MOCK_STATUS.UPDATE_ANCILLARY_PAYMENT_TYPE) {
			return this.api.INDRA_get<INDRAAncillariesSelectionConfirmation>(MOCK_URL_UPDATE_ANCILLARY_PAYMENT_TYPE);
		} else {
			return this.api.INDRA_put<INDRAAncillariesSelectionConfirmation>(URL_ANCILLARIES_SELECTION, ancillariesSelection);
		}
	}

	public INDRA_applyAncillariesToOtherFlights(addedAncillaries: INDRAAddOnAncillary[], pnr: any) {
		const selection = [];
		addedAncillaries.forEach(addOnAncillary => {
			selection.push({
				amount: 1,
				code: addOnAncillary.code,
				idPax: addOnAncillary.paxId,
				paxTattoo: addOnAncillary.paxTatto
			});
		});

		if (selection.length > 0) {
			const param = {
				ancillaryList: [{
					itemId: addedAncillaries[0].itemId,
					type: addedAncillaries[0].type,
					selection: selection,
				}],
				pnr: pnr
			};

			return this.api.INDRA_post<INDRAAncillariesSelectionConfirmation>(URL_ANCILLARIES_APPLY_ALL_FLIGHTS, param);
		}
	}

	public INDRA_changeAncillariesPaymentToCash(pnr, ancillaryList) {
		// get ancillaries that were payed with Miles
		const ancillariesToUpdate = ancillaryList.itemsAdded.filter(anc => {
			if (anc.payWithMiles) {
			  return anc;
			}
		});

		if (ancillariesToUpdate) {
			// ancillaries that needs to update payment by type
			const ancillaryTypes = Array.from(new Set(ancillariesToUpdate.map((item: any) => item.type)));
			this.INDRA_updateSelectionAndPayment(ancillaryTypes, pnr, ancillariesToUpdate);
		}
	}

	INDRA_updateSelectionAndPayment(ancillaryTypes, pnr, ancillariesToUpdate) {
		let count = 0;
		let ancillaryToUpdate;
		let ancType;

		from(ancillaryTypes).pipe(concatMap(el => {
			count++;
			const ancillary = ancillariesToUpdate.filter(ancillary => ancillary.type === el);
			ancillaryToUpdate = ancillary;
			ancType = el;
			this.INDRA_addAncillariesSelectionItems(ancillary);
			return this.INDRA_updateAncillariesPaymentType(pnr, false, ancillary)

		})).subscribe(res => {
			if (!(res['status'] && res['status'] == '200')) {
				this.INDRA_handleAncillaryHubError(ancillariesToUpdate, ancType);
				this.paymentInfoService.setUpdateBookingTotals(true);				
			} else {
				this.ancillariesShoppingCartSrv.INDRA_updateAncillaries(ancillaryToUpdate);
				if (count == ancillaryTypes.length) {
					setTimeout(() => {
						this.paymentInfoService.setUpdateBookingTotals(true);
					}, 1000);
				}
			}
		},
		error => {
			this.INDRA_handleAncillaryHubError(ancillariesToUpdate, ancType);
			this.paymentInfoService.setUpdateBookingTotals(true);				
		});
	}

	INDRA_handleAncillaryHubError(ancillariesToUpdate, type) {
		const ancillaryToRemove = ancillariesToUpdate.filter(anc => anc.type == type);
		this.ancillariesShoppingCartSrv.INDRA_deleteAncillaries(ancillaryToRemove);
	}

	INDRA_setCurrentAddedAncMiles(data){
		let addedAncMiles = this.currentAddedAncMiles;
		this.currentAddedAncMiles = data + addedAncMiles;
	}

	INDRA_getCurrentAddedAncMiles(){
		return this.currentAddedAncMiles;
	}

	INDRA_clearCurrentAddedAncMiles(){
		this.currentAddedAncMiles = 0;
	}
	
	INDRA_getPayWithMilesByFlightId(flightID, isChecked, ancType) {
		let obj = {
			flightID: flightID,
			isChecked: isChecked,
			ancType: ancType
		}

		if (this.payWithMilesFlightList && this.payWithMilesFlightList.length > 0) {
			let isExisting: boolean = false;
			this.payWithMilesFlightList.map(data => {
				if (data.flightID == obj.flightID && data.ancType == ancType) {
					data.isChecked = obj.isChecked
					isExisting = true;
					return;
				}
			});

			if (!isExisting) {
				this.payWithMilesFlightList.push(obj);
			}
		} else {
			this.payWithMilesFlightList.push(obj);
		}
	}


	INDRA_getFlightPayWithMilesStatus(flightID, ancType) {
		if (this.payWithMilesFlightList && this.payWithMilesFlightList.length > 0) {
			let isCheckedStatus: boolean = false;
			this.payWithMilesFlightList.map(data => {
				if (data.flightID == flightID && data.ancType == ancType) {
					isCheckedStatus = data.isChecked;
				}
			});
			return isCheckedStatus;
		} else {
			return false;
		}
	}

}
